import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertLiteComponent } from '@lockton-apps/shared/ui/lui';

@Component({
    selector: 'la-invite-requirements-dialog-content',
    imports: [CommonModule, AlertLiteComponent],
    template: `<div class="vstack gap-2">
    <lui-alert-lite
      [compact]="true"
      level="danger"
      i18n
      *ngIf="!hasBroker"
      data-test="noBrokerAlert"
    >
      <span class="fw-b"
        >Please assign the relevant broker to this renewal before sending the
        invite.</span
      >
      In order to assign a broker proceed to the ‘enquiries’ tab and hover over
      the context menu on the relevant policy row and click the broker
      icon.</lui-alert-lite
    >
    <lui-alert-lite
      [compact]="true"
      level="danger"
      i18n
      *ngIf="!hasContact"
      data-test="noContactAlert"
    >
      <span class="fw-b"
        >At least one client contact must be assigned to this renewal before
        sending the invite.</span
      >
      In order to assign a contact proceed to the ‘enquiries’ tab and click on
      the context menu on the relevant policy row.</lui-alert-lite
    >
  </div>`,
    styleUrls: ['./invite-requirements-dialog-content.component.scss']
})
export class InviteRequirementsDialogContentComponent {
  @Input() hasContact!: boolean;
  @Input() hasBroker!: boolean;
}
